export default "__VITE_ASSET__BNm0muI2__"